// Croqui: `components/Segmented.tsx`. Abas de lista, presets de período, live/test.

import { cn } from '../../lib/cn.ts';

export interface SegItem {
  id: string;
  label: string;
  count?: number;
  /** Tinta do ponto à esquerda (`ModeToggle`). */
  dot?: 'green' | 'muted';
}

/**
 * Controle segmentado. O ativo ganha superfície de cartão.
 *
 * `role="group"` + `aria-pressed`: são botões de filtro, não abas de painel, não há
 * `tabpanel` por trás. `label` vira o nome acessível do grupo.
 */
export function Segmented({
  items,
  value,
  onChange,
  label,
  className,
}: {
  items: SegItem[];
  value: string;
  onChange?: (id: string) => void;
  label: string;
  className?: string;
}) {
  return (
    <fieldset
      aria-label={label}
      className={cn(
        // `flex-wrap`: oito abas com contagem passam de 1024 numa linha só (medido em
        // `/admin/withdrawals`: 1393px de `scrollWidth` com `body` em 1024).
        'inline-flex flex-wrap gap-0.5 rounded-xl border border-border bg-input p-[3px]',
        className,
      )}
    >
      {items.map((item) => {
        const on = item.id === value;
        return (
          <button
            key={item.id}
            type="button"
            aria-pressed={on}
            onClick={() => {
              onChange?.(item.id);
            }}
            className={cn(
              'inline-flex h-8 min-h-10 items-center gap-2 whitespace-nowrap rounded-control px-3 text-13 font-medium transition-colors duration-150 ease-out-quint sm:min-h-0',
              on ? 'bg-card text-text' : 'text-muted hover:text-text',
            )}
          >
            {item.dot !== undefined && (
              <span
                className={cn(
                  'size-[7px] rounded-pill',
                  on ? (item.dot === 'green' ? 'bg-green' : 'bg-muted') : 'bg-rail',
                )}
              />
            )}
            {item.label}
            {item.count !== undefined && (
              <span
                // `muted` sobre `kbd` dá 4,05:1 (abaixo de AA); o contador fica em `text`
                // nas duas abas e a hierarquia vem do rótulo, não do número.
                className="rounded-md bg-kbd px-1.5 py-px text-11 font-semibold tabular-nums text-text"
              >
                {item.count}
              </span>
            )}
          </button>
        );
      })}
    </fieldset>
  );
}
